import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { usePageTitle } from "../../hooks/usePageTitle";
import PlatformStreakIndicator from "../PlatformStreakIndicator";
import TrialBanner from "../TrialBanner/TrialBanner";
import AddBanksPill from "../AddBanksPill/AddBanksPill";
import FeedbackPill from "../FeedbackPill/FeedbackPill";
import {
  EMPTY_PLATFORM_SUMMARY,
  platformSummaryToStreakStats,
} from "../../constants/dashboardStats";
import "./Topbar.scss";

import profileIcon from "../../assets/profile-icon.svg";
import { Dropdown, Image, NavDropdown } from "react-bootstrap";

export const Topbar = (props: {
  title: string;
  titleAddon?: ReactNode;
}): JSX.Element => {
  usePageTitle(props.title);
  const { user, logout, platformSummary } = useUser();
  const studentView = user?.type === "student";
  const streakStats = platformSummaryToStreakStats(platformSummary ?? EMPTY_PLATFORM_SUMMARY);

  const UserMenu = (
    <Image
      src={profileIcon}
      alt="UserName profile image"
      roundedCircle
      style={{ width: "30px" }}
    />
  );

  return (
    <div id="topBar">
      <div className="topbar-title-area">
        <h1>{props.title}</h1>
        {props.titleAddon}
      </div>
      <div className="topbar-actions">
        <FeedbackPill />
        {studentView ? <AddBanksPill /> : null}
        {studentView ? <TrialBanner /> : null}
        {studentView ? <PlatformStreakIndicator stats={streakStats} /> : null}
        <div id="profileAreaWrapper">
          <div id="profileArea">
            <NavDropdown id="nav-dropdown" title={UserMenu}>
              <Dropdown.Header>{user?.firstName} {user?.lastName}</Dropdown.Header>
              <Dropdown.Divider />
              <Dropdown.Item as={Link} to="/settings" eventKey="settings">
                Settings
              </Dropdown.Item>
              <Dropdown.Item eventKey="logout" onClick={logout}>
                Logout
              </Dropdown.Item>
            </NavDropdown>
          </div>
        </div>
      </div>
    </div>
  );
};
